export function updateNoise (_stat, _data) { 
    let data = _data
    for(let i in data){
        if(data[i]['ARP_SE']==="GMP"){
            if(data[i]['NMT_NO']>=21){
                
            }   else {
                let id = data[i]['ARP_SE'] + data[i]['NMT_NO'].toString()
                let entity = _stat.cesiumInstance.viewer.entities.getById(id)
                entity.label.text['_value'] = Math.floor(Number(data[i]['NMT_LVL'])).toString()
            }
        } else if(data[i]['ARP_SE']==="PUS"){
            if(data[i]['NMT_NO']>=10){
                
            }   else {
                let id = data[i]['ARP_SE'] + data[i]['NMT_NO'].toString()
                let entity = _stat.cesiumInstance.viewer.entities.getById(id)
                entity.label.text['_value'] = Math.floor(Number(data[i]['NMT_LVL'])).toString()
            }
        }else if(data[i]['ARP_SE']==="CJU"){
            if(data[i]['NMT_NO']>=7){
                
            }   else {
                let id = data[i]['ARP_SE'] + data[i]['NMT_NO'].toString()
                let entity = _stat.cesiumInstance.viewer.entities.getById(id)
                entity.label.text['_value'] = Math.floor(Number(data[i]['NMT_LVL'])).toString()
            }
        }
       
    }
}

export function updateNoiseForAdmin (_stat, _data) { 
    let data = _data
    for(let i in data){
        let id = data[i]['ARP_SE'] + data[i]['NMT_NO'].toString()
        let entity = _stat.cesiumInstance.viewer.entities.getById(id)
        entity.label.text['_value'] = data[i]['NMT_LVL']
    }
}

export function clearNoise (stat) { 
    for(let i in stat.cesiumInstance.viewer.entities.values){
        if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='noiseSensorPoint'){
            stat.cesiumInstance.viewer.entities.values[i].label.text['_value'] = ""
        }
      }
}